'use strict';

localizer.$inject = ["gettextCatalog", "common", "$q", "$localStorage", "tmhDynamicLocale"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.localizer = localizer;

var _nl = require('./../../assets/po/nl.po');

var _nl2 = _interopRequireDefault(_nl);

var _fr = require('./../../assets/po/fr.po');

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function localizer(gettextCatalog, common, $q, $localStorage, tmhDynamicLocale) {
    var isLanguageLoaded = false;
    var languageChangeEvent = new Event('LanguageChange');

    gettextCatalog.setStrings('nl', _nl2.default.nl);
    gettextCatalog.setStrings('fr', _fr2.default.fr);

    return {
        addLanguageChangeEvent: addLanguageChangeEvent,
        init: init,
        getCurrentLanguage: getCurrentLanguage,
        setLanguage: setLanguage
    };

    function init(lang) {

        return setLanguage(lang);
    }

    function getCurrentLanguage() {
        return gettextCatalog.getCurrentLanguage();
    }

    function setLanguage(lang) {
        common.log.info('set language to:', lang);

        var isSameLanguage = lang === getCurrentLanguage() && isLanguageLoaded;
        if (isSameLanguage) {
            return $q.when(lang);
        }

        angular.element('html').attr('lang', lang);

        // Set the current language before the promise returns, otherwise the language is not highlighted in the footer
        gettextCatalog.setCurrentLanguage(lang);

        // set locale (for formatting of dates and currencies)
        tmhDynamicLocale.set(lang);

        // set text catalog
        common.log.info('load localization file', lang);

        // set local storage
        window.localStorage.setItem('language', lang);

        $localStorage.language = lang;
        languageChangeEvent.raise(lang);
    }

    function addLanguageChangeEvent(callback) {
        return languageChangeEvent.addHandler(callback);
    }
}

function Event(name) {
    this._name = name;
    this._callbacks = [];
}

Event.prototype = function () {
    function addHandler(cb) {
        var ctx = this;
        this._callbacks.push(cb);
        return function () {
            ctx.removeHandler(cb);
        };
    }
    function removeHandler(cb) {
        var idx = this._callbacks.findIndex(function (item) {
            return item === cb;
        });
        if (idx >= 0) {
            this._callbacks.splice(idx, 1);
        }
    }
    function raise() {
        for (var _iterator = this._callbacks, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var cb = _ref;

            cb.apply(null, arguments);
        }
    }

    return {
        addHandler: addHandler,
        removeHandler: removeHandler,
        raise: raise
    };
}();


//////////////////
// WEBPACK FOOTER
// ./common/services/localizer.js
// module id = 815
// module chunks = 0